import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { globalServices } from "../../../Services/global.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { Modal } from "react-bootstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import Select from "react-select";
import { AuthContext } from "../../../Contexts/AuthContext";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import AsyncSelect from "react-select/async";
import CardWrap from "../../Common/CardWrap";
import { retailStateService } from "../../../Services/AccountingServices/retailState.service";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import * as dateHelper from "../../../Helpers/DateHelper";
import { useHistory } from "react-router-dom";
import { roles } from "../../../Config/Roles";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;
registerLocale("hr", hr);
registerLocale("en", en);

const Index = () => {
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);
  const history = useHistory();
  const { t: translator } = useTranslation();
  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });
  const { userId, useAccounting, roleId } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [articleList, setArticleList] = useState([]);
  const [articleCard, setArticleCard] = useState([]);
  const [articleCardPagination, setArticleCardPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [prodDetailsPagination, setProdDetailsPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [prodDetails, setProdDetails] = useState([]);
  const [update, setUpdate] = useState(false);
  const [search, setSearch] = useState({
    storeId: 0,
    sortName: "Name",
    isAsc: true,
    storeId: 0,
    searchText: "",
  });

  const [obj, setObj] = useState({
    productGuid: "",
    code: "",
    name: "",
    quantity: 0,
    price: 0,
    productGroupGuid: "",
    productGroupName: "",
    isShow: false,
  });

  const [objProd, setObjProd] = useState({
    documentNumber: null,
    date: null,
    partnerName: "",
    note: "",
    storeName: "",
    isShow: false,
  });

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");

    updateLocName("retail-state");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  }, []);

  useEffect(() => {
    if (update) {
      retailStateService
        .searchArticleList(
          search.storeId,
          search.sortName,
          search.isAsc,
          search.searchText,
          pagination.pageIndex,
          pagination.pageSize,
        )
        .then((res) => {
          setArticleList(res.data.data);
          setPagination({ ...pagination, totalCount: res.data.totalCount });
          setIsLoading(false);
        })
        .catch((err) => console.log(err));
    }
  }, [update]);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenantsRobno(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant),
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));

        if (Number(roleId) === roles.owner && result.length === 1) {
          const tenantId =
            Number(localStorage.getItem("tenantId")) > 0
              ? Number(localStorage.getItem("tenantId"))
              : 0;

          const tenant = result.find((x) => x.id === tenantId) || null;

          setValue("tenantId", tenant);
          handleOnChangeTenantId(tenant ? [tenant] : null);
        }

        return result;
      })
      .catch((err) => err);
  };

  const getStores = (tenant) => {
    globalServices
      .getStoresByTenantId(tenant)
      .then((res) => {
        setStores(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleToSearch = () => {
    setIsLoading(true);
    setUpdate(new Date());
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setObj({
        isShow: true,
        productGuid: row.productGuid,
        code: row.code,
        name: row.name,
        quantity: row.quantity,
        price: row.price,
        productGroupGuid: row.productGroupGuid,
        productGroupName: row.productGroupName,
      });

      retailStateService
        .aricleCardSearch(
          search.storeId,
          row.productGuid,
          search.searchText,
          articleCardPagination.pageIndex,
          articleCardPagination.pageSize,
        )
        .then((res) => {
          setArticleCard(res.data.data);
          setArticleCardPagination({
            ...pagination,
            totalCount: res.data.totalCount,
          });
          setIsLoading(false);
        })
        .catch((err) => console.log(err));
    },
  };

  const rowEventsCard = {
    onClick: (e, row, rowIndex) => {
      retailStateService
        .documentDetails(row.documentGuid)
        .then((res) => {
          setProdDetails(res.data.data);
        })
        .catch((err) => console.log(err));

      retailStateService
        .getDocumentById(row.documentGuid)
        .then((res) => {
          setObjProd({
            isShow: true,
            documentNumber: res.data.data.documentNumber,
            date: res.data.data.date,
            partnerName: res.data.data.partnerName,
            note: res.data.data.note,
            storeName: res.data.data.storeName,
          });
        })
        .catch((err) => console.log(err));
    },
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const handleArticleCardTableChange = (type, { page, sizePerPage }) => {
    setArticleCardPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const handleProdDetailsTableChange = (type, { page, sizePerPage }) => {
    setProdDetailsPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const handleClose = () => {
    setObj({ ...obj, isShow: false });
  };

  const handleCloseDocDetails = () => {
    setObjProd({ ...objProd, isShow: false });
  };

  const RemoteAll = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="productGuid"
        data={data}
        columns={columns}
        rowEvents={rowEvents}
        noDataIndication={translator("No-Data")}
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const RemoteAllCard = ({
    data,
    page,
    sizePerPage,
    totalSize,
    onTableChange,
  }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="documentDetailGuid"
        data={data}
        columns={columnsCard}
        rowEvents={rowEventsCard}
        noDataIndication={translator("No-Data")}
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const RemoteAllProdDetails = ({
    data,
    page,
    sizePerPage,
    totalSize,
    onTableChange,
  }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        // remote
        keyField="productGuid"
        data={data}
        columns={columnsProdDetails}
        noDataIndication={translator("No-Data")}
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: "EUR",
    }).format(Number(cell));
  }

  function docTypeFormatter(cell) {
    return translator(cell);
  }

  const { SearchBar } = Search;

  const columns = [
    {
      dataField: "code",
      text: translator("RetailState-Code"),
    },
    {
      dataField: "name",
      text: translator("RetailState-Table-ProductName"),
    },
    {
      dataField: "productGroupName",
      text: translator("RetailState-GruopName"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "price",
      text: translator("RetailState-Price"),
      formatter: currencyFormatter,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "quantity",
      text: translator("RetailState-Quantity"),
      hidden: Boolean(isMobile),
    },
  ];

  const columnsCard = [
    {
      dataField: "documentNumber",
      text: translator("RetailStateDetail-DocNumber"),
    },
    {
      dataField: "documentTypeName",
      text: translator("RetailStateDetail-DocumentTypeName"),
      formatter: docTypeFormatter,
    },
    {
      dataField: "quantityIn",
      text: translator("RetailStateDetail-QuantityIn"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "quantityOut",
      text: translator("RetailStateDetail-QuantityOut"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "priceIn",
      text: translator("RetailStateDetail-PriceIn"),
      formatter: currencyFormatter,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "priceOut",
      text: translator("RetailStateDetail-PriceOut"),
      formatter: currencyFormatter,
      hidden: Boolean(isMobile),
    },
  ];

  const columnsProdDetails = [
    {
      dataField: "productName",
      text: translator("RetailStateDetail-ProdName"),
    },
    {
      dataField: "priceOut",
      text: translator("ProductPrice"),
      formatter: currencyFormatter,
      hidden: Boolean(isMobile),
    },
    {
      dataField: "quantityOut",
      text: translator("ProductQuantity"),
    },
  ];

  const handleOnChangeTenantId = (event) => {
    if (!event) return;
    setValue("storeTag", null);
    setArticleList([]);

    getStores(event[0].id);

    return event[0];
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Main-Sidebar-StateOfRetail")}</span>
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <form className="row" onSubmit={handleSubmit(handleToSearch)}>
              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label htmlFor="ddlTenants">
                      {translator("InvIssReport-Filters-Tenants")}
                    </label>
                    <Controller
                      as={AsyncSelect}
                      control={control}
                      name="tenantId"
                      rules={{
                        validate: function (value) {
                          if (!value) return false;
                          return value.value === 0 ? false : true;
                        },
                      }}
                      onChange={handleOnChangeTenantId}
                      defaultOptions={true}
                      loadOptions={promiseOptions}
                      placeholder={translator("Select-Tenant")}
                    />
                    {errors.tenantId && errors.tenantId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("InvIssReport-Filters-StoreTag")}</label>
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      name="storeId"
                      placeholder={translator("SelectStoreTag")}
                      rules={{
                        required: true,
                      }}
                      onChange={function (event) {
                        setSearch({ ...search, storeId: event[0].id });
                        setArticleList([]);
                        return event[0];
                      }}
                      options={
                        stores &&
                        stores.map((e) => ({
                          id: e.id,
                          label: e.name,
                          value: e.name,
                        }))
                      }
                    />
                    {errors.storeId && (
                      <>
                        {errors.storeId.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <label>{""}</label>
                    <div className="form-group">
                      <button
                        className="btn btn-primary pull-left mt-2"
                        type="submit"
                      >
                        <span className="icon icon-search"></span>{" "}
                        {translator("InvIssReport-Btn-Search")}
                      </button>
                    </div>
                  </div>
                </>
              }
            </form>
          </fieldset>

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={articleList}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}
          <Modal
            show={obj.isShow}
            backdrop="static"
            keyboard={false}
            size={"xl"}
          >
            <Modal.Body>
              <CardWrap
                subtitle={translator("ReatailState-ProductDetailsTitle")}
              >
                <form className="row">
                  <div className="col-lg-4">
                    <fieldset className="scheduler-border">
                      <legend className="scheduler-border">
                        {translator("InitialState-IndexData")}
                      </legend>
                      <div className="form-group">
                        <div>
                          <label>
                            <b>{translator("ReatailState-ProdCode")}:</b>{" "}
                            {obj.code}
                          </label>
                        </div>
                        <div>
                          <label>
                            <b>{translator("ReatailState-ProdName")}:</b>{" "}
                            {obj.name}
                          </label>
                        </div>
                        <div>
                          <label>
                            <b>{translator("ReatailState-ProdQuantity")}:</b>{" "}
                            {obj.quantity}
                          </label>
                        </div>
                        <div>
                          <label>
                            <b>{translator("ReatailState-ProdPrice")}:</b>{" "}
                            {currencyFormatter(obj.price)}
                          </label>
                        </div>
                        <div>
                          <label>
                            <b>{translator("ReatailState-ProdGroupName")}:</b>{" "}
                            {obj.productGroupName}
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-lg-8">
                    <fieldset className="scheduler-border">
                      <legend className="scheduler-border">
                        {translator("ReatailState-DocumentDetailsTable")}
                      </legend>
                      <ToolkitProvider
                        keyField="documentDetailGuid"
                        data={articleCard}
                        columns={columnsCard}
                        search
                      >
                        {(props) => (
                          <>
                            <div className="form-group">
                              <SearchBar
                                {...props.searchProps}
                                placeholder={translator("Search")}
                                value={search.searchText}
                              />
                            </div>

                            <hr />
                            <RemoteAllCard
                              {...props.baseProps}
                              data={articleCard}
                              page={articleCardPagination.pageIndex + 1}
                              sizePerPage={articleCardPagination.pageSize}
                              totalSize={articleCardPagination.totalCount}
                              onTableChange={handleArticleCardTableChange}
                            />
                          </>
                        )}
                      </ToolkitProvider>
                    </fieldset>
                  </div>
                </form>
              </CardWrap>
            </Modal.Body>
            <Modal.Footer>
              <button
                onClick={handleClose}
                type="button"
                className="btn btn-outline-secondary"
              >
                {translator("General-Close")}
              </button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={objProd.isShow}
            backdrop="static"
            keyboard={false}
            size={"xl"}
            centered
          >
            <Modal.Body>
              <CardWrap subtitle={translator("DocumentDetails")}>
                <form className="row">
                  <div className="col-lg-4">
                    <fieldset className="scheduler-border">
                      <legend className="scheduler-border">
                        {translator("InitialState-IndexData")}
                      </legend>
                      <div className="form-group">
                        <div>
                          <label>
                            <b>{translator("InitialState-DocumentNumber")}:</b>{" "}
                            {objProd.documentNumber}
                          </label>
                        </div>
                        <div>
                          <label>
                            <b>{translator("InitialState-Date")}:</b>{" "}
                            {dateHelper.formatUtcToDate(objProd.date)}
                          </label>
                        </div>
                        <div>
                          <label>
                            <b>{translator("InitialState-Note")}:</b>{" "}
                            {objProd.note}
                          </label>
                        </div>
                        <div>
                          <label>
                            <b>{translator("InitialState-StoreName")}:</b>{" "}
                            {objProd.storeName}
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-lg-8">
                    <fieldset className="scheduler-border">
                      <legend className="scheduler-border">
                        {translator("InitialState-Items")}
                      </legend>
                      <RemoteAllProdDetails
                        data={prodDetails}
                        page={prodDetailsPagination.pageIndex + 1}
                        sizePerPage={prodDetailsPagination.pageSize}
                        totalSize={prodDetails?.length || 0}
                        onTableChange={handleProdDetailsTableChange}
                      />
                    </fieldset>
                  </div>
                </form>
              </CardWrap>
            </Modal.Body>
            <Modal.Footer>
              <button
                onClick={handleCloseDocDetails}
                type="button"
                className="btn btn-outline-secondary"
              >
                {translator("General-Close")}
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Index;
